<template>
  <Accordion title="Dados da Movimentação">
    <Grid cols-4 gap-5>
      <InputNumber :modelValue="localValue.id" disabled label="Código" />
      <Select :items="type" :modelValue="localValue.type" label="Tipo" required :error="localErrors.type" disabled />
      <InputZoom
        required
        clearable
        label="Local Origem"
        :modelValue="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse"
        database="warehouse"
        item-value="id"
        item-text="name"
        :filter="[{ column: 'type', operator: '!=', value: 'physic' }]"
        placeholder="Selecione o depósito"
        disabled />
      <InputZoom required label="Protocolo" clearable v-model="localValue.orderProtocol" :error="localErrors.orderProtocol" database="os" item-value="protocolo" v-model:complete-object="completeProtocol" placeholder="Selecione o protocolo" />
      <InputDateTime :modelValue="localValue.date" label="Data" required :error="localErrors.date" disabled />

      <InputZoom
        v-model="localValue.idConstructionProject"
        clearable
        label="Obra"
        :error="localErrors.idConstructionProject"
        database="constructionProject"
        item-text="protocolo"
        item-value="id"
        v-model:complete-object="completeObject"
        placeholder="Selecione a obra" />

      <InputText :modelValue="localValue.applicationFont" clearable label="Fonte" :error="localErrors.applicationFont" disabled placeholder="Selecione a fonte de importação" />

      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" :disabled="modelValue.idCorrection" />
    </Grid>
  </Accordion>
</template>

<script setup>
import { reactive, ref, watch } from 'vue'

const type = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
  { label: 'Aplicação', value: 'application' },
  { label: 'Correção de Aplicação', value: 'applicationCorrection' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
const completeProtocol = ref(null)

watch(
  () => props.modelValue,
  (newValue) => {
    if (!newValue) return
    Object.assign(localValue, newValue)
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue || {}
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
}, { deep: true })
</script>
